const FETCH_PRODUCT_STORE_REQUEST = 'FETCH_PRODUCT_STORE_REQUEST'
const FETCH_PRODUCT_STORE_SUCCESS = 'FETCH_PRODUCT_STORE_SUCCESS'
const FETCH_PRODUCT_STORE_FAILURE = 'FETCH_PRODUCT_STORE_FAILURE'
const QUANTITY_CHANGE = 'QUANTITY_CHANGE'
const FETCH_CNET_CONTENT_CHECK_REQUEST = 'FETCH_CNET_CONTENT_CHECK_REQUEST'
const FETCH_CNET_CONTENT_CHECK_UPDATE = 'FETCH_CNET_CONTENT_CHECK_UPDATE'
const UPDATE_SWATCH_MODAL_OPEN = 'UPDATE_SWATCH_MODAL_OPEN'

export {
  FETCH_PRODUCT_STORE_REQUEST,
  FETCH_PRODUCT_STORE_SUCCESS,
  FETCH_PRODUCT_STORE_FAILURE,
  QUANTITY_CHANGE,
  FETCH_CNET_CONTENT_CHECK_REQUEST,
  FETCH_CNET_CONTENT_CHECK_UPDATE,
  UPDATE_SWATCH_MODAL_OPEN
}
